import _setAvatarApi from "./avatarApi";
import _setObject3DApi from "./object3DApi";
import _setParticleSystemApi from "./particleSystemApi";
import _setSceneApi from "./sceneApi";
import {_setSpriteApi, _removeSpriteApi} from "./spriteApi";
import _setVideoApi from "./videoApi";
import _setCameraApi from "./cameraApi";

export function _setApis(object) {
  if (!object) return;

  if (object.type === "Sprite") {
    _setSpriteApi.bind(this)(object);
    return;
  }

  if (object.type === "Scene") {
    _setSceneApi.bind(this)(object);
    return;
  }

  _setObject3DApi.bind(this)(object);

  if (object.userData.type === "particleSystem") {
    _setParticleSystemApi.bind(this)(object);
  } else if (object.userData.type === "avatar") {
    _setAvatarApi.bind(this)(object);
  } else if (object.userData.type === "video") {
    _setVideoApi.bind(this)(object);
  } else if (object.isCamera) {
    _setCameraApi.bind(this)(object);
  }
}

export function _removeApis(object) {
  if (object.type === "Sprite") {
    _removeSpriteApi.bind(this)(object);
  }
}
